import React from 'react'
import styled from 'styled-components/macro'

interface Props {
  text: string
  position?: 'left' | 'right'
  disabled?: boolean
  style?: React.CSSProperties
  children: React.ReactNode
}

export const TooltipText = ({ text, position = 'right', disabled = false, style, children }: Props) => {
  //@karl @jared, fade in tooltip, wait 0.5s for tooltip to show up after mouseover
  return (
    <Tooltip>
      {children}
      {!disabled && (
        <TooltipOverlay position={position} style={style}>
          {text}
        </TooltipOverlay>
      )}
    </Tooltip>
  )
}

const TooltipOverlay = styled.span<{ position: 'left' | 'right' }>`
  visibility: hidden;
  min-width: 120px;
  width: 200px;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 20px 10px;
  position: absolute;
  z-index: 999;
  top: -15px;
  font-size: 12px;
  font-weight: normal;
  left: ${({ position }) => (position === 'right' ? '110%' : 'unset')};
  right: ${({ position }) => (position === 'left' ? '110%' : 'unset')};

  ${({ position }) => (position === 'right' ? '&:after' : '&:before')} {
    content: '';
    position: absolute;
    top: 25px;
    margin-top: -5px;
    border-width: 5px;
    border-style: solid;
    left: ${({ position }) => (position === 'right' ? 'unset' : '100%')};
    right: ${({ position }) => (position === 'left' ? 'unset' : '100%')};
    border-color: ${({ position }) =>
      position === 'right'
        ? 'transparent #000000 transparent transparent'
        : 'transparent transparent transparent #000000'};
  }
`

const Tooltip = styled.div`
  position: relative;
  display: inline-block;

  &:hover ${TooltipOverlay} {
    visibility: visible;
  }
`
